import { useCore } from '@/composables/core'

export function resolveInvopopAdapterUrl (path: string): string {
  if (!path.startsWith('/')) {
    throw new Error('path must start with /')
  }

  const { store } = useCore()
  const country = store.state.app.country
  const url = new URL(window.location.origin)

  if (country && !url.hostname.startsWith(`${country}.`)) {
    url.hostname = `${country}.${url.hostname}`
  }

  return `${url.origin}${path}`
}

export function invopopAdapterHeaders (): Record<string, string> {
  const { store } = useCore()
  const accessToken = store.state.identity.accessToken

  if (!accessToken) {
    return {}
  }

  return {
    'X-Access-Token': accessToken,
  }
}
